export const localStorage: Storage = window.localStorage;